<template>
    <div class="repair-items app-region blank-t-v blank-l-h blank-r-h">
        <a-card :bordered="false">
            <div class="table-page-search-wrapper">
                <H2 style="margin-bottom: 10px">积分商品</H2>
            </div>
            <div class="table-operator" style="margin: 20px 0">
                <a-button type="primary" icon="plus" @click="add">新增积分商品</a-button>
            </div>
            <a-spin tip="加载中..." :spinning="table.loading">
                <!-- 表格 -->
                <a-table :columns="columns" :data-source="table.data" rowKey="id" :pagination="table.page"
                    @change="handlePageChange">
                    <span slot="goods" slot-scope="data">
                        <span><img :src="data.image" height="30" width="30" style="margin-right:10px"></span>
                        <span>{{data.title}}</span>
                    </span>
                    <span slot="status" slot-scope="data">
                        <div>
                            <a-switch :checked="data.status == 'normal'" @change="setintegralGoodsStatus(data)" />
                        </div>
                    </span>
                    <span slot="action" slot-scope="text, data">
                        <template>
                            <a @click="handleEdit(data)">编辑</a>
                            <a-divider type="vertical" />
                            <a @click="handleDelete(data)" style="color:#fb8387">删除</a>
                        </template>
                    </span>
                </a-table>
            </a-spin>

            <a-modal :title="modal.type===0?'新增':'编辑'" :confirm-loading="modal.loading" v-model="modal.show"
                :width="1000" :footer="null" destroy-on-close centered>
                <integralGoodsModal @submit="submit" ref="integralModal" :integralData="modal.integralData" />
            </a-modal>
        </a-card>
    </div>
</template>
  
<script>
import integralGoodsService from "@/io/goods/integralGoods.js";
import integralGoodsModal from './modules/integralGoodsInfo.vue'

export default {
    name: "integralGoods",
    components: {
        integralGoodsModal
    },
    data() {
        let self = this;
        return {
            modal: {
                show: false,
                loading: false,
                // 0新增，1编辑
                type: 0,
                integralData: null
            },
            rules: {},
            columns: [
                {
                    title: "商品信息",
                    key: "goods",
                    scopedSlots: { customRender: "goods" },
                },
                {
                    title: "积分",
                    dataIndex: "score",
                },
                {
                    title: "现金",
                    dataIndex: "price",
                },
                {
                    title: "操作",
                    key: "action",
                    scopedSlots: { customRender: "action" },
                },
            ],
            table: {
                loading: false,
                data: [],
                page: {
                    total: 10,
                    current: 1,
                    pageSize: 10,
                    showQuickJumper: true,
                    showSizeChanger: true,
                    showTotal() {
                        return `共${self.table.page.total}条`;
                    },
                },
            },
        };
    },
    mounted() {
        this.getList();
    },
    methods: {
        //   获取分类列表
        async getList() {
            this.table.loading = true;
            const { page } = this.table;
            const res = await integralGoodsService.list({
                page: page.current,
                limit: page.pageSize,
            }).then(res => {
                this.table.data = res.data.rows;
                this.table.page.total = res.data.total;
                this.table.loading = false;
            })

        },
        // 编辑
        handleEdit(data) {
            this.modal.integralData = data
            this.modal.type = 1
            this.modal.show = true
        },
        // 新建
        add() {
            this.modal.type = 0
            this.modal.show = true;
            this.modal.integralData = {}
        },
        submit() {
            this.modal.show = false
            this.getList()
        },
        // 删除分类
        async handleDelete({ id }) {
            this.$confirm({
                title: '提示',
                content: '确定要删除该积分商品吗？',
                onOk: () => {
                    integralGoodsService.del({ goods_id: id }).then(res => {
                        if (res.code === 1) {
                            this.$message.success(res.msg)
                            this.getList()
                        } else {
                            this.$message.error(res.msg)
                        }
                    })
                }
            })

        },
        handlePageChange(page) {
            this.table.page.current = page.current;
            this.table.page.pageSize = page.pageSize;
            this.getList();
        },

    },
};
</script>
  